/**
 * 通用轮询函数接口定义
 */
export interface PollingOptions {
  /** 轮询间隔（毫秒），默认2秒 */
  delay?: number;
  /** 重试次数，默认10次 */
  retry?: number;
  /** 总轮询次数，默认无限轮询 */
  maxPollingCount?: number;
}

/**
 * 通用轮询函数
 * @param callback 轮询回调函数
 * @param options 轮询配置选项
 * @returns 接口数据
 */
export const pollUntilCompleted = async <T>(callback: () => Promise<T>, {
  delay = 2000,
  retry = 10,
  maxPollingCount,
}: PollingOptions = {}): Promise<T> => {
  let retryCount = 0;
  let pollingCount = 0;
  
  while (true) {
    // 检查是否达到最大轮询次数（如果设置了的话）
    if (maxPollingCount !== undefined && pollingCount >= maxPollingCount) {
      throw new Error(`Reached maximum polling count ${maxPollingCount} times`);
    }
    
    try {
      // 请求回调
      const statusData = await callback();
      if (statusData) {
        return statusData;
      }
      pollingCount++;
      await new Promise(resolve => setTimeout(resolve, delay));
    } catch (error) {
      if (retryCount >= retry) {
        throw error;
      }
      retryCount++;
      pollingCount++;
      await new Promise(resolve => setTimeout(resolve, delay));
    }
  }
};